import { Link } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { dashboardApi } from "@/lib/dashboard";

export function MyTasksWidget() {
  const q = useQuery({
    queryKey: ["dashboard", "my-tasks"],
    queryFn: () => dashboardApi.myTasks(),
    refetchInterval: 30_000,
    refetchIntervalInBackground: false,
  });

  return (
    <Card>
      <CardHeader><CardTitle>My Tasks</CardTitle></CardHeader>
      <CardContent>
        {q.isLoading ? (
          <Skeleton className="h-9 w-28" />
        ) : q.isError || !q.data ? (
          <p className="text-sm text-muted-foreground">Couldn't load tasks.</p>
        ) : q.data.openCount === 0 ? (
          <p className="text-sm text-muted-foreground">No open tasks — you're clear.</p>
        ) : (
          <Link to="/tasks" className="block hover:underline">
            <span className="text-3xl font-semibold">{q.data.openCount}</span>{" "}
            <span className="text-sm text-muted-foreground">open</span>
            {q.data.overdueCount > 0 && (
              <span className="text-destructive text-sm"> · {q.data.overdueCount} overdue</span>
            )}
          </Link>
        )}
      </CardContent>
    </Card>
  );
}
